export const ICONS = {
    x16: {
        arrow_down: 'arrow_down',
        arrow_up: 'arrow_up',
        arrow_left: 'arrow_left',
        arrow_right: 'arrow_right',
        camera: 'camera',
        question: 'question',
        cross: 'cross',
        close: 'close',
        checked: 'checked'
    },
    x24: {
        arrow_down: 'arrow_down',
        arrow_left: 'arrow_left',
        arrow_up: 'arrow_up',
        arrow_right: 'arrow_right',
        cross: 'cross',
        burger: 'burger',
        calendar: 'calendar',
        card: 'card',
        checked: 'checked',
        cross_small: 'cross_small',
        enter: 'enter',
        login: 'login',
        logout: 'logout',
        error: 'error',
        funds: 'funds',
        home: 'home',
        info: 'info',
        list: 'list',
        profile: 'profile',
        success: 'success',
        time_warning: 'time_warning',
        warning: 'warning',
        warning_red: 'warning_red',
        edit: 'edit',
        download: 'download',
        shield: 'shield',
        warning_blue: 'warning_blue',
        plus: 'plus',
        minus: 'minus',
        eye_open: 'eye_open',
        eye_closed: 'eye_closed'
    },
    x32: {
        quote: 'quote'
    },
    x38: {
        facebook: 'facebook',
        twitter: 'twitter',
        linkedin: 'linkedin',
        youtube: 'youtube',
        instagram: 'instagram'
    },
    x48: {
        calendar: 'calendar',
        check: 'check',
        clock: 'clock',
        dollar: 'dollar',
        loan: 'loan',
        minus: 'minus'
    },
    x64: {
        success: 'success',
        warning: 'warning',
        error: 'error',
        failure: 'failure',
        money: 'money',
        banknote: 'banknote',
        calendar: 'calendar',
        check: 'check',
        clock: 'clock',
        dialog: 'dialog',
        dollar: 'dollar',
        finger: 'finger',
        five: 'five',
        loan: 'loan',
        minus: 'minus'
    }
};
export const ICON_SIZES = {
    x16: 'x16',
    x24: 'x24',
    x32: 'x32',
    x38: 'x38',
    x48: 'x48',
    x64: 'x64'
};
